import React, { useState } from "react";
import "./search-result.css";
import StarIcon from "@material-ui/icons/Star";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
export default function Searchresult({
  img,
  location,
  title,
  description,
  star,
  price,
  total,
}) {
  const [liked, setLiked] = useState(false);
  return (
    <div className="searchResult">
      <img src={img} alt="" />
      {liked ? (
        <FavoriteIcon
          className="searchResult_heart"
          onClick={() => setLiked(!liked)}
        />
      ) : (
        <FavoriteBorderIcon
          onClick={() => setLiked(!liked)}
          className="searchResult_heart"
        />
      )}
      <div className="searchResult_info">
        <div className="searchResult_infoTop">
          <p>{location}</p>
          <h3>{title}</h3>
          <p>_____</p>
          <p>{description}</p>
        </div>
        <div className="searchResult_infoBottom">
          <div className="searResult_star">
            <StarIcon className="searchResult_starIcon" />
            <p>
              <strong>{star}</strong>
            </p>
          </div>
          <div className="searchResult_price">
            <h2>{price}</h2>
            <p>{total}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
